import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';

import { AngularConfirmComponent } from './angular-confirm.component';

@NgModule({
    imports: [ ModalModule.forRoot(),],
    declarations: [AngularConfirmComponent],
    exports: [AngularConfirmComponent],
    providers: []
})
export class AngularConfirmModule { }


// WEBPACK FOOTER //
// ./src/angular_library/components/confirm/angular-confirm.module.ts